import { MpfInputBaseProps, mpfInputDefaults } from '../MpfInput/MpfInputBaseProps';

// ENG-20629 Temporarily removing the ability to add PDFs due to a vulnerability
// To revert, replace ACCEPT_ATTR value with 'image/jpeg,image/png,image/tiff,application/pdf,.doc,.docx';
const ACCEPT_ATTR = 'image/jpeg,image/png,image/tiff,.doc,.docx';

export interface MpfAttachmentsProps extends Omit<
  MpfInputBaseProps,
  'modelValue' | 'initialValue'
> {
  initialValue?: File[] | null;
  maxFiles?: number;
  maxFileSize?: number;
  modelValue?: File[] | null;
  accept?: string;
  multiple?: boolean;
}

export type MpfAttachmentsEmits = {
  (e: 'update:modelValue', value: File[]): void;
};

export const mpfAttachmentsDefaults = {
  ...mpfInputDefaults,
  modelValue: null,
  maxFiles: 10,
  maxFileSize: 2 * 1024 * 1024, // 10MB
  accept: ACCEPT_ATTR,
  size: 'small',
};
